export const FIELDS = {
  AMOUNT: 'amount'
};

export const INITIAL_VALUES = {
  [FIELDS.AMOUNT]: ''
};
